"use strict";

class bb_multiStep {
  constructor(form) {
    this.form = form;
    this.fieldsets = this.form.querySelectorAll("fieldset");
    this.activeFieldset = 0;
    this.fileUploadInput = this.form.querySelector("input[type=file]");
    this.fileUploadList = this.form.querySelector(".bb-input-file-uploaded");
    this.forwardButtons = this.form.querySelectorAll("[data-stepper = forward]");
    this.backButtons = this.form.querySelectorAll("[data-stepper = back]");
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.checkboxConsent = this.form.querySelector("#userConsent");
    this.consentWrapper = this.form.querySelector("#consentWrapper");
    this.inputFields = this.form.querySelectorAll("[userinput='true']");
    this.filePreview = document.getElementById("pre_itemFiles");
    this.submit_iframe = document.getElementById("submit_iframe");
    this.progressBar = document.querySelectorAll(".bb-progess-bar-step");
    this.map = this.createMap("map-input");
    this.mapPreview = this.createMap("map-preview", 1);
    this.markerInput;
    this.markerPreview;
    this.mailFormat = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    // Do Event Listener
    this.forwardButtons.forEach((element, index) => {
      element.addEventListener("click", this.goForward.bind(this));
    });

    this.backButtons.forEach((element, index) => {
      element.addEventListener("click", this.goBack.bind(this));
    });

    this.inputFields.forEach((element, index) => {
      element.addEventListener("change", this.bindFields.bind(this));
    });

    this.inputFields.forEach((element, index) => {
      element.addEventListener("change", this.doFieldValidate.bind(this));
    });

    this.fileUploadInput.addEventListener("change", this.showFiles.bind(this));

    this.submitButton.addEventListener("click", this.userConsent.bind(this));

    this.map.addEventListener("click", this.createMarker.bind(this));
  }

  userConsent(event) {
    if (this.checkboxConsent.checked != true) {
      event.preventDefault();
      this.consentWrapper.classList.add("warning");
    } else {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.form.style.display = "none";
      this.submit_iframe.style.display = "block";
      this.submit_iframe.contentDocument.body.innerHTML =
        "<div class='bb-archiv-load-wrapper'><div class='bb-archiv-loader'><div></div><div></div><div></div><div></div></div></div>";
      this.submit_iframe.contentDocument.head.innerHTML =
        "<style>body{display:flex;flex-direction:column;justify-content:center;align-items:center;font-family:monospace;overflow:hidden;width:100%;height:100vh}.bb-archiv-loader{display:inline-block;position:relative;width:160px;height:100px}.bb-archiv-loader div{position:absolute;top:33px;width:26px;height:26px;border-radius:50%;background:#879d24;animation-timing-function:cubic-bezier(0,1,1,0)}.bb-archiv-loader div:nth-child(1){left:16px;animation:lds-ellipsis1 .6s infinite}.bb-archiv-loader div:nth-child(2){left:16px;animation:lds-ellipsis2 .6s infinite}.bb-archiv-loader div:nth-child(3){left:64px;animation:lds-ellipsis2 .6s infinite}.bb-archiv-loader div:nth-child(4){left:112px;animation:lds-ellipsis3 .6s infinite}@keyframes lds-ellipsis1{0%{transform:scale(0)}100%{transform:scale(1)}}@keyframes lds-ellipsis3{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes lds-ellipsis2{0%{transform:translate(0,0)}100%{transform:translate(48px,0)}}</style>";
    }
  }

  bindFields(event) {
    let srcId = event.srcElement.id;
    let preId = "preview_".concat(event.srcElement.id);
    document.getElementById(preId).textContent = event.srcElement.value;
  }

  goForward() {
    if (this.doPageValidate()) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.fieldsets[this.activeFieldset].classList.add("hidden");
      this.reloadProgressBar("forward");
      this.activeFieldset++;
      this.fieldsets[this.activeFieldset].classList.remove("hidden");
      this.resizeMap();
    }
  }
  goBack() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.fieldsets[this.activeFieldset].classList.add("hidden");
    this.reloadProgressBar("back");
    this.activeFieldset--;
    this.fieldsets[this.activeFieldset].classList.remove("hidden");
    this.resizeMap();
  }

  doFieldValidate(event) {
    if (event.srcElement.attributes.type) {
      if (event.srcElement.attributes.type.value == "email") {
        if (this.mailFormat.test(event.srcElement.value)) {
          event.srcElement.classList.remove("warning");
          return;
        }
      }
    }
    if (event.srcElement.attributes.type) {
      if (event.srcElement.value != "" && event.srcElement.attributes.type.value != "email") {
        event.srcElement.classList.remove("warning");
        return;
      }
    }
    if (!event.srcElement.attributes.type) {
      event.srcElement.classList.remove("warning");
      return;
    }
  }

  doPageValidate() {
    if (this.activeFieldset == 0) {
      let errors = [];
      if (this.fileUploadList.textContent === "Dateityp nicht erlaubt!") {
        errors.push(this.fileUploadList);
      }
      if (this.fileUploadList.textContent === "Die Gesamtgröße von 50mb wurde überschritten!") {
        errors.push(this.fileUploadList);
      }
      if (this.inputFields[0].value == "") {
        errors.push(this.inputFields[0]);
      }
      if (this.inputFields[1].value == "") {
        errors.push(this.inputFields[1]);
      }

      if (errors != "") {
        errors.forEach((element, index) => {
          element.classList.add("warning");
        });
        return false;
      }
      return true;
    }
    if (this.activeFieldset == 1) {
      let errors = [];
      if (this.inputFields[2].value == "") {
        errors.push(this.inputFields[2]);
      }
      if (this.inputFields[3].value == "") {
        errors.push(this.inputFields[3]);
      }
      if (this.inputFields[4].value == "" || !this.mailFormat.test(this.inputFields[4].value)) {
        errors.push(this.inputFields[4]);
      }
      if (this.inputFields[5].value == "") {
        errors.push(this.inputFields[5]);
      }
      if (this.inputFields[6].value == "") {
        errors.push(this.inputFields[6]);
      }

      if (errors != "") {
        errors.forEach((element, index) => {
          element.classList.add("warning");
        });
        return false;
      }
      return true;
    }
    return true;
  }

  reloadProgressBar(direction) {
    if (direction === "forward") {
      let nextStep = this.activeFieldset + 1;
      this.progressBar[this.activeFieldset].innerHTML = "<i class='fi flaticon-check'></i>";
      this.progressBar[this.activeFieldset].classList.remove("active-step");
      this.progressBar[nextStep].classList.add("active-step");
    }
    if (direction === "back") {
      let nextStep = this.activeFieldset - 1;
      this.progressBar[this.activeFieldset].classList.remove("active-step");
      this.progressBar[nextStep].classList.add("active-step");
    }
  }

  createMap(id, preview) {
    let map = L.map(id).setView([20, 0], 2);
    L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
    if (preview) {
      map.scrollWheelZoom.disable();
      map.touchZoom.disable();
      map.doubleClickZoom.disable();
      map.scrollWheelZoom.disable();
      map.boxZoom.disable();
      map.keyboard.disable();
      map.removeControl(map.zoomControl);
    }
    return map;
  }

  resizeMap() {
    this.map.invalidateSize();
    this.mapPreview.invalidateSize();
  }

  createMarker(event) {
    if (this.markerInput) {
      this.map.removeLayer(this.markerInput);
      this.mapPreview.removeLayer(this.markerPreview);
    }
    this.markerInput = new L.marker(event.latlng).addTo(this.map);
    document.getElementById("oModuleMappingLat").value = event.latlng.lat;
    document.getElementById("oModuleMappingLng").value = event.latlng.lng;

    this.markerPreview = new L.marker(event.latlng).addTo(this.mapPreview);
    let latLngs = [this.markerPreview.getLatLng()];
    let markerBounds = L.latLngBounds(latLngs);
    this.mapPreview.fitBounds(markerBounds);
  }

  hasAllowedMimeType(element) {
    let itemType = element.name.match(/[0-9a-z]+$/i)[0];
    let isAllowed = allowedTypes.filter((allowedTypes) => allowedTypes === itemType.toLowerCase());
    if (isAllowed.length == 0) {
      return true;
    }
  }

  showFiles() {
    let data = this.fileUploadInput.files;
    let files = [];
    for (let element of data) {
      if (this.hasAllowedMimeType(element)) {
        this.fileUploadList.textContent = "Dateityp nicht erlaubt!";
        this.filePreview.textContent = "Dateityp nicht erlaubt!";
        return;
      }
      files.push(element.name);
    }

    let fileSizes = Array.from(data, (x) => x["size"]);
    let totalSize = fileSizes.reduce((pv, cv) => pv + cv, 0);
    let maxSize = this.form.querySelector("#MAX_FILE_SIZE").value;
    if (totalSize >= maxSize) {
      this.fileUploadList.textContent = "Die Gesamtgröße von 256mb wurde überschritten!";
      this.filePreview.textContent = "Die Gesamtgröße von 256mb wurde überschritten!";
      return;
    }

    if (files.length == 0) {
      this.fileUploadList.classList.remove("warning");
      this.fileUploadList.textContent = "Keine Dateien ausgewählt!";
      this.filePreview.textContent = "Keine Dateien ausgewählt!";
    } else {
      this.fileUploadList.classList.remove("warning");
      this.fileUploadList.textContent = files.join(", ");
      this.filePreview.textContent = files.join(", ");
    }
  }
}

function checkForMultiStepForms() {
  const multiStepForms = document.querySelectorAll(".bb-form-multistep");

  if (multiStepForms.length > 0) {
    multiStepForms.forEach((element, index) => {
      new bb_multiStep(multiStepForms[index]);
    });
  }
}

document.addEventListener("DOMContentLoaded", checkForMultiStepForms);
